<div _ngcontent-ng-c3205094933="" class="header-title issues-page-header">
  <span _ngcontent-ng-c3205094933="" class="issues-title-text"> Issues </span>
  <img src="assets/images/common/beta.svg" alt="beta" />
</div>

<div class="issues">
  <app-prime-table
    #table
    class="table-component"
    queryParamProperty="issues"
    [data$]="issuesCurrentPage$"
    [rowsPerPage]="50"
    [columns]="columns()"
    [isLoading]="(isLoading$ | async) === true"
    (rowSelected)="rowSelected($event)"
    (rowUnselected)="rowUnselected()"
    [withCheckboxSelection]="false"
    [withActions]="false"
    [sortedColumn$]="sortedColumn$"
    [pageInfo]="pageInfo$.value"
    [tabelWithIcon]="false"
    tableNotFoundText="No issues found"
    tableNotFoundIcon="assets/images/common/no-results-found.svg"
  />
</div>
